export default __webpack_public_path__ + "static/media/CaptionMDImg.fea2e8ea.jpg";